// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// ANTD
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Title from 'components/text/Title';
import Subtitle from 'components/text/Subtitle';

const Container = styled.div`
  margin: auto;
  text-align: center;
`;

const NoStudioYet = () => (
  <PageContainer>
    <Container>
      <Icon type="exclamation-circle-o" style={{ fontSize: 75, color: '#ddd' }} />
      <Title style={{ marginTop: 16 }}>CREATE A STUDIO!</Title>
      <Subtitle style={{ marginTop: 8 }}>
        Before you can start to add clients, please complete your studio profile...
      </Subtitle>
      <div style={{ marginTop: 16 }}>
        <Link to="/app/studio">
          <Button size="large" onClick={() => {}} type="primary">
            GO TO MY STUDIO!
          </Button>
        </Link>
      </div>
    </Container>
  </PageContainer>
);

export default NoStudioYet;



// WEBPACK FOOTER //
// ./src/components/common/NoStudioYet/index.js